/* ============================================================
   CasasCAD — Modales por hash (portado del monolito lp-site.js, solo lo de modales).
   Abre/cierra los modales #catalogo-precios / #agendar-reunion / #agendar-visita.
   El ENVÍO del lead lo captura el conector de theme.liquid (sendBeacon al worker);
   aquí solo va la UX: slots, máscara de teléfono y bloque de gracias.
   ============================================================ */
(function () {
  'use strict';

  var modalMap = {
    '#catalogo-precios': 'modal-catalogo-precios',
    '#agendar-reunion': 'modal-agendar-reunion',
    '#agendar-visita': 'modal-agendar-visita'
  };

  function openModal(id) {
    closeModals(false);
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('open');
    document.body.classList.add('modal-open');
    var f = el.querySelector('input, select, button.modal-close');
    if (f && window.innerWidth > 900) { try { f.focus(); } catch (e) {} }
  }
  function closeModals(cleanHash) {
    document.querySelectorAll('.modal-overlay.open').forEach(function (m) { m.classList.remove('open'); });
    document.body.classList.remove('modal-open');
    if (cleanHash !== false && modalMap[location.hash]) {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }
  function checkHash() { var id = modalMap[location.hash]; if (id) openModal(id); }

  document.addEventListener('click', function (ev) {
    var a = ev.target.closest('a[href]');
    if (a) {
      var href = a.getAttribute('href');
      if (modalMap[href]) { ev.preventDefault(); openModal(modalMap[href]); return; }
    }
    if (ev.target.closest('.modal-close')) { closeModals(); return; }
    if (ev.target.classList && ev.target.classList.contains('modal-overlay')) { closeModals(); }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeModals(); });
  window.addEventListener('hashchange', checkHash);
  checkHash(); // deep-link: casascad.net/#catalogo-precios abre el modal solo

  /* ---------- Slots (próximos 3 días hábiles, 10:00 y 15:00) ---------- */
  function getSlots() {
    var out = [], added = 0, d = new Date();
    d.setDate(d.getDate() + 1);
    while (added < 3) {
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) {
        var s = d.toLocaleDateString('es-CL', { weekday: 'long', day: 'numeric', month: 'short' });
        var label = s.charAt(0).toUpperCase() + s.slice(1);
        var iso = d.toISOString().split('T')[0];
        out.push({ label: label + ' · 10:00', date: iso, time: '10:00' });
        out.push({ label: label + ' · 15:00', date: iso, time: '15:00' });
        added++;
      }
      d.setDate(d.getDate() + 1);
    }
    return out;
  }
  document.querySelectorAll('.slot-chips[data-build-slots]').forEach(function (container) {
    getSlots().forEach(function (s) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'slot-chip';
      b.textContent = s.label;
      b.addEventListener('click', function () {
        container.querySelectorAll('.slot-chip').forEach(function (c) { c.classList.remove('selected'); });
        b.classList.add('selected');
        var form = container.closest('form');
        if (form) {
          form.elements.date.value = s.date;
          form.elements.time.value = s.time;
          form.elements.slotLabel.value = s.label;
        }
      });
      container.appendChild(b);
    });
  });

  /* ---------- Máscara de teléfono +56 9 ---------- */
  document.querySelectorAll('.modal-form input[type="tel"]').forEach(function (input) {
    input.addEventListener('blur', function () {
      var d = input.value.replace(/\D/g, '');
      if (d.indexOf('56') === 0 && d.length > 9) d = d.slice(2);
      if (d.length === 8) d = '9' + d;
      if (d.length === 9 && d.indexOf('9') === 0) {
        input.value = '+56 9 ' + d.slice(1, 5) + ' ' + d.slice(5, 9);
      }
    });
  });

  /* ---------- Submit: el conector captura el lead; aquí solo mostramos gracias ---------- */
  document.querySelectorAll('.modal-form').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      function done() {
        form.classList.add('sent');
        form.style.display = 'none';
        var t = document.getElementById(form.dataset.thanks || '');
        if (t) { t.classList.add('show'); t.style.display = 'block'; }
        // Redirigir a WhatsApp con el mensaje predeterminado + nombre/comuna
        // (el cliente inicia el chat → Valeria responde; sin riesgo de baneo)
        if (form.dataset.wa) {
          var url = form.dataset.wa;
          var nombre = form.elements.nombre && form.elements.nombre.value;
          var comuna = form.elements.comuna && form.elements.comuna.value;
          var extra = '';
          if (nombre) extra += ' Soy ' + nombre + '.';
          if (comuna) extra += ' Construyo en ' + comuna + '.';
          if (extra) url += encodeURIComponent(extra);
          setTimeout(function () { window.location.href = url; }, 900);
        }
      }
      // honeypot anti-spam: fingir éxito
      if (form.elements.sitio_web && form.elements.sitio_web.value) { done(); return; }
      // slots obligatorios en reunión/visita
      if (form.dataset.slots && form.elements.date && !form.elements.date.value) {
        var chips = form.querySelector('.slot-chips');
        if (chips) { chips.style.outline = '2px solid #c0392b'; chips.style.outlineOffset = '4px'; }
        return;
      }
      done();
    });
  });
})();
